export const EMAIL_TEMPLATE = 'email_template/'
export const EMAIL_TEMPLATE_ALL = 'email_template/all'
export const SEND_MAIL = `${EMAIL_TEMPLATE}send-message`
